<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <v-dialog v-model="completadoDialogo" width="500">
          <v-card>
            <v-card-title class="headline success lighten-2" primary-title>
              {{ $t('cambiar_completado') }}
            </v-card-title>

            <v-card-text>
              <div class="body-1 pt-4">
                {{ $t('cambiar_completado_msg') }}
              </div>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" text @click="completadoDialogo = false">
                {{ $t('cerrar' | capitalize) }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-row align="center" justify="center" class="pa-2 ma-4">
          <v-card width="500px">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>{{ $t('cambiar_tit') }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-alert v-model="error.activado" type="error" dismissible dense outlined>
                {{ error.mensaje }}
              </v-alert>
              <v-text-field
                  :label="$t('label_contrasenya')"
                  v-model="contrasenya"
                  type="password"
                  :rules="[requerido, counter6]"
                  prepend-inner-icon="mdi-lock"
              ></v-text-field>
              <v-text-field
                  :label="$t('label_contrasenya_confirmacion')"
                  v-model="contrasenya_confirmacion"
                  :rules="[requerido, contrasenyaConfirmacion]"
                  type="password"
                  prepend-inner-icon="mdi-lock"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-row no-gutters class="mt-0">
                <v-col cols="12" class="text-right pr-3">
                  <v-btn color="primary"
                         :disabled="!cambiarValido()"
                         :loading="cambiando"
                         @click="registro()">
                    <span class="mr-2">{{ $t('cambiar') }}</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {HttpHelper} from "../../comunes/helpers/HttpHelper";

export default {
  name: 'RegistroPagina',
  components: {},
  data: () => ({
    contrasenya: "",
    contrasenya_confirmacion: "",
    cambiando: false,
    error: {
      activado: false,
      mensaje: ""
    },
    completadoDialogo: false
  }),
  methods: {
    requerido(value) {
      return !!value || this.$t('requerido')
    },
    counter6(value) {
      return value.length >= 6 || this.$t('minimo6')
    },
    contrasenyaConfirmacion(confirmacion) {
      return this.contrasenya == confirmacion || this.$t('contr_coin');
    },
    cambiarValido() {
      if (this.contrasenya.length <= 0) return false;
      if (this.contrasenya_confirmacion.length <= 0) return false;

      if (this.contrasenya != this.contrasenya_confirmacion) return false;

      return true;
    },
    registro() {
      let params = {
        token: this.$route.query.token,
        contrasenya: this.contrasenya,
        contrasenya_confirmacion: this.contrasenya_confirmacion
      };

      HttpHelper.post("auth/cambiar-contrasenya-token", params)
          .then(() => {
            this.error.activado = false;
            this.completadoDialogo = true;
            this.usuario = "";
            this.nombre = "";
            this.contrasenya = "";
            this.contrasenya_confirmacion = "";
          })
          .catch((error) => {
            this.error.mensaje = error && Object.prototype.hasOwnProperty.call(error, 'mensaje')
                ? error.mensaje : this.$t('error_registro');
            this.error.activado = true;
          })
    }
  }
};
</script>

<style lang="scss" scoped>
</style>

<style lang="scss" scoped>
</style>

<!-- @formatter:off -->
<i18n>
{
  "es": {
    "cambiar_tit": "Introduzca una nueva contraseña",
    "label_contrasenya": "Contraseña",
    "label_contrasenya_confirmacion": "Repite la contraseña",
    "requerido": "Requerido",
    "minimo6": "Mínimo 6 carácteres",
    "req_email": "Correo electrónico incorrecto",
    "contr_coin": "Las contraseñas deben coincidir",
    "error_cambiar": "Ha ocurrido un error desconocido.",
    "cambiar": "Cambiar",
    "cambiar_completado": "Contraseña cambiada",
    "cambiar_completado_msg": "Se ha cambiado la contraseña de forma correcta ya puede iniciar sesión para empezar a utilizar la aplicación.",
    "cerrar": "Cerrar"
  }
}
</i18n>
<!-- @formatter:on -->